import { useState } from "react";
import { Avatar, cx } from "@amber/ui";

export function Portrait({
  name,
  url,
  size = "sm",
  muted = false,
}: {
  name: string;
  url: string | null;
  size?: "sm" | "lg";
  muted?: boolean;
}) {
  const [failed, setFailed] = useState(false);
  if (url && !failed)
    return (
      <img
        src={url}
        alt=""
        onError={() => {
          setFailed(true);
        }}
        className={cx("flex-none rounded-full bg-surface-3 object-cover", size === "lg" ? "size-14" : "size-[26px]")}
      />
    );
  return <Avatar name={name} size={size === "lg" ? "lg" : "md"} muted={muted} />;
}
